import { PageHeader } from '@fukuri-admins/ui/common';
import { getClientContractListLink } from '~/utils/getLinks';

/**
 * 企業契約期間 編集ヘッダー Presentation コンポーネント
 *
 * breadcrumb: 企業契約期間 → 編集
 *
 * - パンくず末尾の「編集」を実企業名（{clientName}の契約期間の編集）に置き換え、
 *   契約プラン情報の表示を追加するのは T02（PEN-979）で実装予定
 */
export const EditClientContractTermHeaderPresentation: React.FC = () => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[
      { label: '企業契約期間', href: getClientContractListLink() },
      { label: '編集' },
    ]}
  />
);
